module.exports = __webpack_public_path__ + "img/nlic_gallery9.63025df2.jpg";